export const nflTeams: string[] = [
  "Arizona Cardinals",
  "Atlanta Falcons",
  "Baltimore Ravens",
  "Buffalo Bills",
  "Carolina Panthers",
  "Chicago Bears",
  "Cincinnati Bengals",
  "Cleveland Browns",
  "Dallas Cowboys",
  "Denver Broncos",
  "Detroit Lions",
  "Green Bay Packers",
  "Houston Texans",
  "Indianapolis Colts",
  "Jacksonville Jaguars",
  "Kansas City Chiefs",
  "Las Vegas Raiders",
  "Los Angeles Chargers",
  "Los Angeles Rams",
  "Miami Dolphins",
  "Minnesota Vikings",
  "New England Patriots",
  "New Orleans Saints",
  "New York Giants",
  "New York Jets",
  "Philadelphia Eagles",
  "Pittsburgh Steelers",
  "San Francisco 49ers",
  "Seattle Seahawks",
  "Tampa Bay Buccaneers",
  "Tennessee Titans",
  "Washington",
];

export const nbaTeams: string[] = [
  "Atlanta Hawks",
  "Boston Celtics",
  "Brooklyn Nets",
  "Charlotte Hornets",
  "Chicago Bulls",
  "Cleveland Cavaliers",
  "Dallas Mavericks",
  "Denver Nuggets",
  "Detroit Pistons",
  "Golden State Warriors",
  "Houston Rockets",
  "Indiana Pacers",
  "LA Clippers",
  "Los Angeles Lakers",
  "Memphis Grizzlies",
  "Miami Heat",
  "Milwaukee Bucks",
  "Minnesota Timberwolves",
  "New Orleans Pelicans",
  "New York Knicks",
  "Oklahoma City Thunder",
  "Orlando Magic",
  "Philadelphia 76ers",
  "Phoenix Suns",
  "Portland Trail Blazers",
  "Sacramento Kings",
  "San Antonio Spurs",
  "Toronto Raptors",
  "Utah Jazz",
  "Washington Wizards",
];

export const mlbTeams: string[] = [
  "Oakland Athletics",
  "Pittsburgh Pirates",
  "San Diego Padres",
  "Seattle Mariners",
  "San Francisco Giants",
  "St. Louis Cardinals",
  "Tampa Bay Rays",
  "Texas Rangers",
  "Toronto Blue Jays",
  "Minnesota Twins",
  "Philadelphia Phillies",
  "Atlanta Braves",
  "Chicago White Sox",
  "Miami Marlins",
  "New York Yankees",
  "Milwaukee Brewers",
  "Los Angeles Angels",
  "Arizona Diamondbacks",
  "Baltimore Orioles",
  "Boston Red Sox",
  "Chicago Cubs",
  "Cincinnati Reds",
  "Cleveland Guardians",
  "Colorado Rockies",
  "Detroit Tigers",
  "Houston Astros",
  "Kansas City Royals",
  "Los Angeles Dodgers",
  "Washington Nationals",
  "New York Mets",
];

export const nhlTeams: string[] = [
  "New Jersey Devils",
  "New York Islanders",
  "New York Rangers",
  "Philadelphia Flyers",
  "Pittsburgh Penguins",
  "Boston Bruins",
  "Buffalo Sabres",
  "Montreal Canadiens",
  "Ottawa Senators",
  "Toronto Maple Leafs",
  "Carolina Hurricanes",
  "Florida Panthers",
  "Tampa Bay Lightning",
  "Washington Capitals",
  "Chicago Blackhawks",
  "Detroit Red Wings",
  "Nashville Predators",
  "St. Louis Blues",
  "Calgary Flames",
  "Colorado Avalanche",
  "Edmonton Oilers",
  "Vancouver Canucks",
  "Anaheim Ducks",
  "Dallas Stars",
  "Los Angeles Kings",
  "San Jose Sharks",
  "Columbus Blue Jackets",
  "Minnesota Wild",
  "Winnipeg Jets",
  "Arizona Coyotes",
  "Vegas Golden Knights",
  "Seattle Kraken",
];
